import api from './api'

export type MonthCloseNavStatusResponse = {
  id: number
  ran_at: string
  preferred_equity_incomplete_count: number
  bank_recon_incomplete_count: number
  income_allocation_incomplete_count: number
  benefits_incomplete_count: number
}

export async function getMonthCloseNavStatus(): Promise<MonthCloseNavStatusResponse> {
  const { data } = await api.get<MonthCloseNavStatusResponse>('/month-close-nav-status')
  return data
}
